// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// ProcUnmatchedReceiptReason — source: shared/config/proc_unmatched_receipt_reasons.config.json

export const PROC_UNMATCHED_RECEIPT_REASON_VALUES = ["vendor_shipped_no_po", "sample", "production_output", "found_stock", "other"] as const;
export type ProcUnmatchedReceiptReason = (typeof PROC_UNMATCHED_RECEIPT_REASON_VALUES)[number];

